import { Auth } from 'aws-amplify';

export const setUser = payload => ({
  type: 'SET_USER',
  payload,
});

export const setOrganization = organization => ({
  type: 'SET_ORGANIZATION',
  organization,
});

/**
 *  Sign In Method
 * @param {string} username The username to be signed in or the sign in options
 * @param {string} password The password of the username
 * @returns {promise} A promise resolves the CognitoUser
 */
export const login = async (username, password) => Auth.signIn(username, password);

export const completeNewPassword = async (user, newPassword) => Auth.completeNewPassword(user, newPassword);

/**
 * Get current user's session
 * @returns {promise} A promise resolves to session object if success
 */
export const currentSession = async () => Auth.currentSession();

/**
 * Sign out Method
 */
export const logout = async () => Auth.signOut();
